<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12 text-center pa-6">
          <v-card-title class="justify-center text-h5 font-weight-bold">
            Teya -> Roboot.net Integration
          </v-card-title>
          
          <v-card-text class="my-4">
            <p v-if="!isConnected">Connect your Roboot.net to your Teya smart terminal to start accepting cards.</p>
            <v-alert v-else type="success" dismissible>
              Connected and ready to accept payments!
            </v-alert>
          </v-card-text>

          <v-card-actions class="justify-center">
            <v-btn 
              :color="isConnected ? 'error' : 'primary'" 
              :loading="loading"
              large
              @click="handleTeyaConnection"
            >
              {{ isConnected ? 'Disconnect Teya' : 'Connect to Teya' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  data: () => ({
    loading: false,
    isConnected: false,
  }),
  mounted() {
    // Check if we already have an active session saved
    if (localStorage.getItem('teya_access_token')) {
      this.isConnected = true;
    }
  },
  methods: {
    async handleTeyaConnection() {
      if (this.isConnected) {
        // Disconnect logic
        localStorage.removeItem('teya_access_token');
        this.isConnected = false;
        return;
      }

      this.loading = true;
      try {
        // Request the generated PKCE login URL from your Express backend
        const response = await axios.get('http://localhost:3000/api/teya/auth-url');
        
        // Redirect the whole browser window to Teya login portal
        window.location.href = response.data.url;
      } catch (error) {
        console.error('Failed to initialize Teya auth:', error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>